
export default function SliderItem({item, theme, ribbonFlag, ribbonText}) {
  return (
    <div className="exampleHomePage_sliderItem" style={{border:`0.5px solid ${theme.accent_color}`, color:theme.accent_color, backgroundColor:theme.primary_color}}>
        <div className="exampleHomePage_sliderItem_img"></div>
        <h5 className="exampleHomePage_sliderItem_name">{item.name}</h5>
        <h5 className="exampleHomePage_sliderItem_price">מחיר: {ribbonText === "במבצע!" ? (item.price*item.disValue).toFixed(2) : item.price}₪</h5>
        {ribbonText === "במבצע!" ? <h5 className="exampleHomePage_sliderItem_prevPrice">{item.price}₪</h5> : null}
        {ribbonFlag && <div className='examplehomePage_sliderItem_ribbon' style={{backgroundColor:`${theme.accent_color}`, color:`${theme.primary_color}`}}>{ribbonText}</div>}
      </div>
  )
}
